import { PAUTSummaryData } from "../../../../utils/models";

import classNames from "../pdf.module.scss";
import pdfClasses from "../../../themed/pdf/pdf.module.scss";

import weldNumber from "../../../../assets/paut-images/weldNumber.png";
import viReport from "../../../../assets/paut-images/viReport.png";
import shearwave from "../../../../assets/paut-images/shearwave.png";
import result from "../../../../assets/paut-images/result.png";
import phasedArray from "../../../../assets/paut-images/phasedArray.png";
import mpiReport from "../../../../assets/paut-images/mpiReport.png";
import defectType from "../../../../assets/paut-images/defectType.png";

const PAUTSummary = (props: PAUTSummaryData) => {
  const getResultClassName = (): string => {
    return props.result === "Accepted"
      ? classNames.pautSummaryResultValueAccept
      : classNames.pautSummaryResultValueReject;
  };

  return (
    <div className={classNames.pautSummary}>
      <div className={classNames.pautSummaryResult}>
        <div className={classNames.pautSummaryResultLabel}>Result</div>
        <div className={classNames.pautSummaryResultValue}>
          <span className={getResultClassName()}>{props.result}</span>
        </div>
      </div>

      <table className={pdfClasses["pdf-table"]}>
        <thead>
          <tr>
            <th>Weld Number</th>
            <th>Phased Array (PAUT)</th>
            <th>Visual Inspection Result</th>
            <th>MPI Result</th>
            <th>Shear Wave Result</th>
            <th className={pdfClasses.bgWarning}>Defect Type</th>
            <th className={pdfClasses.bgWarning}>Accept / Reject</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <img src={weldNumber} alt="Weld Number" />
            </td>
            <td>
              <img src={phasedArray} alt="Phased Array (PAUT)" />
            </td>
            <td>
              <img src={viReport} alt="Visual Inspection Result" />
            </td>
            <td>
              <img src={mpiReport} alt="MPI Result" />
            </td>
            <td>
              <img src={shearwave} alt="Shear Wave Result" />
            </td>
            <td>
              <img src={defectType} alt="Defect Type" />
            </td>
            <td>
              <img src={result} alt="Accept / Reject" />
            </td>
          </tr>

          <tr>
            <td>{props.weldNumber}</td>
            <td>{props.phasedArray}</td>
            <td>{props.viResult}</td>
            <td>{props.mpiResult}</td>
            <td>{props.shearWaveResult}</td>
            <td>{props.defectType}</td>
            <td>
              <span className={getResultClassName()}>{props.result}</span>
            </td>
          </tr>
        </tbody>
      </table>

      <div className={classNames.pautSummaryRemark}>
        Remark (If Any): {props.remark}
      </div>
    </div>
  );
};

export default PAUTSummary;
